export default "__VITE_ASSET__3b805705__"